import globalStyles from '../../styles/ButtonGradient.module.css';
import { FiPlay } from 'react-icons/fi';

const StartQuizButton = ({ onClick }) => {
  return (
    <button
      className={globalStyles.button}
      onClick={onClick || (() => console.log('Start Quiz clicked'))}
    >
      <FiPlay className={globalStyles.icon} />
      Start IQ Quiz
    </button>
  );
};

export default StartQuizButton;